import StarRating from '@app-studio-web/ui/components/StarRating'
import { useTranslation } from 'react-i18next'

interface Testimonial {
  textKey: string
  authorKey: string
  detailKey: string
}

const testimonials: Testimonial[] = [
  {
    textKey: 'pages.checkout.testimonials.t1.text',
    authorKey: 'pages.checkout.testimonials.t1.author',
    detailKey: 'pages.checkout.testimonials.t1.detail',
  },
  {
    textKey: 'pages.checkout.testimonials.t2.text',
    authorKey: 'pages.checkout.testimonials.t2.author',
    detailKey: 'pages.checkout.testimonials.t2.detail',
  },
  {
    textKey: 'pages.checkout.testimonials.t3.text',
    authorKey: 'pages.checkout.testimonials.t3.author',
    detailKey: 'pages.checkout.testimonials.t3.detail',
  },
]

export default function TestimonialCarousel() {
  const { t } = useTranslation()

  return (
    <div className="space-y-3">
      <h3 className="text-center text-lg font-bold">
        {t('pages.checkout.testimonials.heading')}
      </h3>
      <div className="flex gap-3 overflow-x-auto pb-2">
        {testimonials.map((testimonial, index) => (
          <div
            key={index}
            className="text-custom-black min-w-[280px] flex-1 rounded-2xl border border-[#9699AE] bg-white p-5"
          >
            <div className="mb-2">
              <StarRating rating={5} />
            </div>
            <p className="mb-3 text-sm leading-relaxed">
              &ldquo;{t(testimonial.textKey)}&rdquo;
            </p>
            <p className="text-sm font-bold">{t(testimonial.authorKey)}</p>
            <p className="text-xs text-[#9699AE]">{t(testimonial.detailKey)}</p>
          </div>
        ))}
      </div>
    </div>
  )
}
